(ns yardwerkz.web.profile.notification-prefs
  "Notification preferences with category toggles."
  (:require
   [uix.core :refer [defui $ use-state use-effect]]
   [io.factorhouse.rfx.core :as rfx]
   [yardwerkz.web.store :as store]
   [yardwerkz.web.router :as router]
   [yardwerkz.web.ui.layout :as layout]
   [yardwerkz.web.ui.components :as ui]
   [yardwerkz.web.ui.icons :as icons]))

(def categories
  [{:id :job-updates  :label "Job Updates"    :desc "Status changes and assignments"}
   {:id :quotes       :label "Quotes"         :desc "New quotes and price updates"}
   {:id :messages     :label "Messages"       :desc "Chat messages from workers"}
   {:id :payments     :label "Payments"       :desc "Payment confirmations and receipts"}
   {:id :promotions   :label "Promotions"     :desc "Special offers and discounts"}])

(defui notification-prefs-page []
  (let [dispatch (rfx/use-dispatch)
        prefs (rfx/use-sub [::store/notification-preferences])
        [local-prefs set-local] (use-state nil)]

    (use-effect
     (fn []
       (dispatch [::store/fetch-notification-preferences])
       js/undefined)
     [dispatch])

    (use-effect
     (fn []
       (when prefs (set-local prefs))
       js/undefined)
     [prefs])

    ($ layout/page-container
       ($ :button {:class "flex items-center text-sm text-gray-500 hover:text-gray-700 mb-4"
                   :on-click #(router/navigate! :profile)}
          ($ icons/ChevronLeft {:size 16})
          ($ :span "Back to Profile"))
       ($ :h1 {:class "text-2xl font-bold text-gray-900 mb-6"} "Notification Preferences")
       ($ :div {:class "space-y-4"}
          (for [{:keys [id label desc]} categories]
            (let [muted? (contains? (set (:muted-categories local-prefs)) id)]
              ($ ui/card {:key id :class "p-4"}
                 ($ :div {:class "flex items-center justify-between"}
                    ($ :div
                       ($ :p {:class "font-medium text-gray-900"} label)
                       ($ :p {:class "text-sm text-gray-500"} desc))
                    ($ :button
                       {:class (str "relative inline-flex h-6 w-11 items-center rounded-full transition-colors "
                                    (if muted? "bg-gray-200" "bg-green-600"))
                        :on-click (fn []
                                    (let [new-muted (if muted?
                                                      (disj (set (:muted-categories local-prefs)) id)
                                                      (conj (set (:muted-categories local-prefs)) id))
                                          new-prefs (assoc local-prefs :muted-categories new-muted)]
                                      (set-local new-prefs)
                                      (dispatch [::store/update-notification-preferences new-prefs])))}
                       ($ :span {:class (str "inline-block h-4 w-4 transform rounded-full bg-white transition-transform "
                                             (if muted? "translate-x-1" "translate-x-6"))}))))))))))
